import React from 'react';
import { motion } from 'framer-motion';

// Fade-in sutil quando uma pagina MF monta. Sem AnimatePresence/exit pra
// evitar flash do fundo #0d1620 do .App durante a transparencia.
// O wrapper externo tem bg branco fixo — assim se houver qualquer instante
// de opacity < 1 do motion.div interno, mostra branco (nao azul).
// Duracao curta (280ms) com easing easeOutExpo pra nao ficar arrastado.
export default function PageTransition({ children }) {
  return (
    <div style={{ background: '#FFFFFF', minHeight: '100vh', width: '100%', maxWidth: '100vw', overflowX: 'clip' }}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: 0.28,
          ease: [0.22, 1, 0.36, 1],
        }}
        style={{ width: '100%', maxWidth: '100vw', overflowX: 'clip' }}
      >
        {children}
      </motion.div>
    </div>
  );
}
